var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',[(!_vm.authenticated && _vm.origin === _vm.testUrl)?_c('Auth',{on:{"authentication":_vm.handleAuthentication}}):_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []

export { render, staticRenderFns }